import React, { useEffect, useRef } from 'react'
import './style.scss'
import $ from 'jquery'

export default function Breadcrumb_Step({step}) {
    let onceMount = useRef(true);
    
    useEffect(() => {
        if(onceMount.current)
        {
            componentInit();
            onceMount.current = false;
        }
    }, [])

    const componentInit = async() => {
        await animateStyleInit();
    }

    const animateStyleInit = () => {
        return new Promise(async resolve => {
            $(".line-wrap").addClass(`acitve-${step}`);
            for(let i = 1; i <= step; i++)
            {
                $(`.point[index="${i}"]`).addClass(`active`);
            }
            resolve();
        })
    }

    return (
        <div className="breadcrumb-step">
            <div className="line-wrap">
                <div className="point" index="1"></div>
                <div className="point" index="_blank"></div>
                <div className="point" index="2"></div>
                <div className="point" index="3"></div>
                <div className="point" index="_blank"></div>
                <div className="point" index="4"></div>
            </div>  
        </div>
    )
}